var locale = {
  locale: 'zh',
  more: '更多',
  custom: '自定义',
  inputPlaceHolder: '请输入文字'
};
export default locale;